// admin-panel/src/components/MarkdownRenderer.js
import ReactMarkdown from 'react-markdown';
import rehypeRaw from "rehype-raw";
import { Box, Text } from '@chakra-ui/react';

export default function MarkdownRenderer({ content }) {

  return (
    <Box
      sx={{
        // Headings
        'h1': {
          fontSize: '20px',
          fontWeight: '700',
          marginBottom: '10px',
          marginTop: '10px',
          color: '#1A202C',
        },
        'h2': {
          fontSize: '18px',
          fontWeight: '600',
          marginBottom: '4px',
          marginTop: '4px',
          color: '#1A202C',
        },
        'h3': {
          fontSize: '16px',
          fontWeight: '600',
          marginBottom: '3px',
          marginTop: '3px',
          color: '#1A202C',
        },
        // Paragraphs
        'p': {
          marginBottom: '2px',
          lineHeight: '1.7',
          color: '#2D3748',
        },
        // Bold text
        'strong': {
          fontWeight: '600',
          color: '#1A202C',
          fontSize: '14px',
        },
        // Lists
        'ul': {
          paddingLeft: '24px',
          marginBottom: '2px',
        },
        'ol': {
          paddingLeft: '24px',
          marginBottom: '2px',
        },
        'li': {
          marginBottom: '2px',
          lineHeight: '1.6',
          color: '#2D3748',
        },
        // Bullet points
        'ul li::marker': {
          color: '#1A202C',
        },
        // Code blocks
        'code': {
          backgroundColor: '#F7FAFC',
          padding: '2px 6px',
          borderRadius: '4px',
          fontSize: '0.9em',
          color: '#1A202C',
        },
        'pre': {
          backgroundColor: '#F7FAFC',
          padding: '12px',
          borderRadius: '8px',
          overflow: 'auto',
          marginBottom: '2px',
        },
        // Tables
        'table': {
          width: '100%',
          borderCollapse: 'collapse',
          marginBottom: '4px',
        },
        'th': {
          backgroundColor: '#F7FAFC',
          padding: '4px',
          textAlign: 'left',
          fontWeight: '600',
          borderBottom: '2px solid #E2E8F0',
        },
        'td': {
          padding: '2px',
          borderBottom: '1px solid #E2E8F0',
        },
        // Blockquotes
        'blockquote': {
          borderLeft: '4px solid #CF008A',
          paddingLeft: '16px',
          marginLeft: '0',
          marginBottom: '4px',
          color: '#4A5568',
          fontStyle: 'italic',
        },
        // Horizontal rules
        'hr': {
          border: 'none',
          borderTop: '1px solid #E2E8F0',
          marginTop: '20px',
          marginBottom: '20px',
        },
      }}
    >
      <ReactMarkdown rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
    </Box>
  );
}
